/* oxlint-disable lingui/no-unlocalized-strings */
// Don't translate for single language organizations
import { Text } from "@medoma/components/Text/Text";

export const GuideTemplateSSHInnerstaden = () => (
  <>
    <Text element="p">ASIH, Avancerad sjukvård i hemmet</Text>
    <Text element="p">
      Vi erbjuder ett alternativ till slutenvård på sjukhus för patienter med
      behov av avancerade sjukvårdinsatser. Du har blivit ansluten till vår
      verksamhet vilket innebär att du har möjlighet att få vård från oss dygnet
      runt i ditt hem. Vi utför våra planerade besök mellan kl: 09-13 men det är
      ditt behov som styr hur ofta vi besöker dig.
    </Text>
    <Text element="p">
      Vi är ett team bestående av läkare, sjuksköterskor, undersköterskor,
      fysioterapeuter, arbetsterapeuter, kurator, dietist och receptarie. Dina
      vårdbehov och din förväntade inskrivningstid hos oss avgör vilka av
      ovanstående personer du kommer möta. önskemål förändras kontinuerligt hos
      oss. Fråga gärna någon i personalen om du tycker något är oklart.
    </Text>
    <Text element="p">
      Du kan kontakta oss direkt på telefon (se telefonlista).
    </Text>
    <Text element="p">
      Vården är avgiftsfri. De läkemedel du ordinerad tillhandahålls av oss och
      är kostnadsfria. För dig som behandlas för cancersjukdom skrivs dina
      cellhämmande läkemedel ut på recept som du får från din behandlande läkare
      på den specialistenhet du tillhör. Det kan vara bra att ha en egen
      termometer och en våg.
    </Text>
    <Text element="p">
      Om du inte längre har behov av avancerad sjukvård i hemmet blir du
      utskriven från vår verksamhet och då kommer vi i samråd med dig att
      planera för din fortsatta vård.
    </Text>
  </>
);
